'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const PageBreadcrumbs = require('../../../global/components/PageBreadcrumbs');
const ContextComponent = require('../../../global/components/ContextComponent');
const { trackBreadcrumbClick } = require('../../actions/pdpTrackingActions');

class Breadcrumbs extends ContextComponent {
    constructor(props) {
        super(props);

        this._handleBreadcrumbClick = this._handleBreadcrumbClick.bind(this);
    }

    _getConfig() {
        const config = [];

        this.props.categories.getCategory().ascendTree(category => {
            // `categories` begin with most specific category e.g. L4 -> L3 -> L2 -> L1 -- add in reverse order
            config.unshift({
                label: category.getName(),
                trackingLabel: `l${category.getLevel()}`,
                path: category.getBrowseUrl(),
            });
        });
        return config;
    }

    _handleBreadcrumbClick({ trackingLabel }) {
        this.context.executeAction(trackBreadcrumbClick, { category: trackingLabel });
    }

    render() {
        return (
            <PageBreadcrumbs
                config={this._getConfig()}
                addInitialConfig
                itemClickCallback={this._handleBreadcrumbClick}
            />
        );
    }
}

Breadcrumbs.propTypes = {
    categories: PropTypes.object.isRequired,
};

module.exports = Breadcrumbs;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Breadcrumbs/Breadcrumbs.jsx